import { LeaveAbsenceColor, type LeaveAbsenceColor as Color } from '@gb-ticket/shared-types';

/** Small legend / list dot. */
export const LEAVE_TYPE_COLOR_CLASS: Record<Color, string> = {
  sky: 'bg-sky-500',
  amber: 'bg-amber-500',
  rose: 'bg-rose-500',
  emerald: 'bg-emerald-500',
  violet: 'bg-violet-500',
  orange: 'bg-orange-500',
  slate: 'bg-slate-500',
  teal: 'bg-teal-500',
  lime: 'bg-lime-500',
  fuchsia: 'bg-fuchsia-500',
  cyan: 'bg-cyan-500',
  stone: 'bg-stone-500',
};

/** Full cell fill for an approved absence. */
export const LEAVE_TYPE_FILL_CLASS: Record<Color, string> = {
  sky: 'bg-sky-500 text-white',
  amber: 'bg-amber-500 text-white',
  rose: 'bg-rose-500 text-white',
  emerald: 'bg-emerald-500 text-white',
  violet: 'bg-violet-500 text-white',
  orange: 'bg-orange-500 text-white',
  slate: 'bg-slate-500 text-white',
  teal: 'bg-teal-500 text-white',
  lime: 'bg-lime-500 text-white',
  fuchsia: 'bg-fuchsia-500 text-white',
  cyan: 'bg-cyan-500 text-white',
  stone: 'bg-stone-500 text-white',
};

/** Same palette at lower opacity for submitted absences. */
export const LEAVE_TYPE_FILL_SUBMITTED_CLASS: Record<Color, string> = {
  sky: 'bg-sky-500/45 text-sky-950 dark:text-sky-50',
  amber: 'bg-amber-500/45 text-amber-950 dark:text-amber-50',
  rose: 'bg-rose-500/45 text-rose-950 dark:text-rose-50',
  emerald: 'bg-emerald-500/45 text-emerald-950 dark:text-emerald-50',
  violet: 'bg-violet-500/45 text-violet-950 dark:text-violet-50',
  orange: 'bg-orange-500/45 text-orange-950 dark:text-orange-50',
  slate: 'bg-slate-500/45 text-slate-950 dark:text-slate-50',
  teal: 'bg-teal-500/45 text-teal-950 dark:text-teal-50',
  lime: 'bg-lime-500/45 text-lime-950 dark:text-lime-50',
  fuchsia: 'bg-fuchsia-500/45 text-fuchsia-950 dark:text-fuchsia-50',
  cyan: 'bg-cyan-500/45 text-cyan-950 dark:text-cyan-50',
  stone: 'bg-stone-500/45 text-stone-950 dark:text-stone-50',
};

export const LEAVE_TYPE_COLOR_LABEL: Record<Color, string> = {
  sky: 'Blau',
  amber: 'Bernstein',
  rose: 'Rose',
  emerald: 'Grün',
  violet: 'Violett',
  orange: 'Orange',
  slate: 'Schiefer',
  teal: 'Petrol',
  lime: 'Lind',
  fuchsia: 'Magenta',
  cyan: 'Cyan',
  stone: 'Stein',
};

export const LEAVE_TYPE_COLOR_OPTIONS = Object.values(LeaveAbsenceColor);

export function fillClassForStatus(
  color: Color,
  status: 'approved' | 'submitted' | null | undefined,
): string {
  if (status === 'submitted') {
    return LEAVE_TYPE_FILL_SUBMITTED_CLASS[color];
  }
  return LEAVE_TYPE_FILL_CLASS[color];
}
